import { queryOptions } from '@tanstack/react-query';
import { compact } from 'es-toolkit';

import { sportySdk } from '../client';
import {
  type RulesQueryVariables,
  type VideoCreationSelectionsInput,
} from './../generated/graphql';

export const ruleKeys = {
  all: 'rules' as const,
  detail: (ruleId: number) => ['rule', ruleId] as const,
};

export const rulesQueryOptions = (
  options: RulesQueryVariables = { allRules: true, limit: 10, page: 0 },
) =>
  queryOptions({
    queryFn: () => sportySdk.rules(options),
    queryKey: [ruleKeys.all, options],
    staleTime: 30 * 1000, // 30 seconds
  });

export const ruleQueryOptions = (ruleId: number) =>
  queryOptions({
    queryFn: () => sportySdk.rule({ ruleId }),
    queryKey: ruleKeys.detail(ruleId),
  });

export const workflowDetailsQueryOptions = () =>
  queryOptions({
    queryFn: () => sportySdk.workflowDetails(),
    queryKey: ['workflowDetails'],
    staleTime: Infinity,
  });

export const videoCreationOptionsQueryOptions = () =>
  queryOptions({
    queryFn: () => sportySdk.videoCreationOptions(),
    queryKey: ['videoCreationOptions'],
    staleTime: Infinity,
  });

export const validateBaseQueryQueryOptions = (baseQuery: string) =>
  queryOptions({
    queryFn: () => sportySdk.validateBaseQuery({ baseQuery }),
    queryKey: ['validateBaseQuery', baseQuery],
    staleTime: Infinity,
  });

export const validateVideoCreationOptionsQueryOptions = (
  videoCreationSelections: VideoCreationSelectionsInput,
) =>
  queryOptions({
    queryFn: () => sportySdk.validateVideoCreationOptions({ videoCreationSelections }),
    queryKey: [
      'validateVideoCreationOptions',
      {
        ...videoCreationSelections,
        // Selection order is meaningless to the API, so normalize it for cache identity
        // while the request keeps the order the user picked.
        videoCreationOptions: compact(videoCreationSelections.videoCreationOptions ?? [])
          .slice()
          .sort(),
      },
    ],
    staleTime: Infinity,
  });
